import { createSignal, onMount } from "solid-js";

import Animation from "@repo/utils-client/Animation";

export default function createInitial() {
  const [initial, setIntial] = createSignal(true);

  onMount(() => {
    Animation.nextFrame(() => {
      setIntial(false);
    });
  });

  return initial;
}
